import Form from "components/Reusable/Form/Form";

interface InviteSubUserCheckboxAgreementI {
  className?: string;
  agreementText: string;
  onAgreementChange: (state: boolean) => void;
  agreementChecked?: boolean;
}
export const InviteSubUserCheckboxAgreement = ({
  agreementText,
  className = "",
  onAgreementChange,
  agreementChecked,
}: InviteSubUserCheckboxAgreementI) => {
  return (
    <div className={className}>
      <Form
        className="invite-user-checkbox-agreement-form"
        submitProps={{
          hidden: true,
        }}
        fieldsProps={{
          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            onAgreementChange(e.target.checked),
        }}
        fields={{
          agreement: {
            fieldKey: "agreement",
            element: "checkbox",
            customTitleElement: () => agreementText,
            className: agreementChecked === false ? "invalid-input" : "",
          },
        }}
      />
    </div>
  );
};
